module.exports = __webpack_public_path__ + "media/insights/pencil_icon-7cdb7a2a.png";